<template>
  <div>
    <div v-for='(cable, index) in arsenal.cables' >
      <div class="cable-row">
        <div class="cable-select-column">
          <CableSelect
            :variant="variant"
            :arsenal_version="arsenal_version"
            :value="arsenal.cables[index]"
            @input="update_cable_selection(index, $event)"
          />
          <div class="error" v-if="cable_has_error(index)">Camera model is required</div>
        </div>
        <div class="cable-price-column">
          <span class="cable-price">{{ cable_price(index) }}</span>
          <a class="remove-cable" v-if="removable_cable(index)" @click.prevent="remove_cable(index)">X</a>
        </div>
      </div>
    </div>

    <div class="text-right"><a class="add-cable" href="#" @click.prevent='add_cable'>+ Add Another Cable</a></div>
  </div>
</template>

<script>
  import CableSelect from 'app/components/orders/CableSelect'

  export default {
    props: ['arsenal_version', 'arsenal', '$v', 'variant'],
    methods: {
      cable_price(index) {
        return index < this.arsenal.quantity ? 'Free' : '$10'
      },
      add_cable() {
        this.arsenal.cables.push('')
        this.$emit('quantity_updated')
      },
      update_cable_selection(index, value) {
        this.arsenal.cables[index] = value
        // NB: This fixes an issue where vuelidation is not aware that the array has been updated
        this.arsenal.cables.push(null)
        this.arsenal.cables.pop()
      },
      removable_cable(index) {
        if (this.arsenal.quantity == 0) return true
        return index >= this.arsenal.quantity && this.arsenal.cables.length > 1
      },
      remove_cable (index) {
        this.arsenal.cables.splice(index, 1)
        this.$emit('quantity_updated')
      },
      cable_has_error(index) {
        return !this.$v.cables.$each[index].required
      }
    },
    components: { CableSelect }
  }
</script>
